import * as PXBColors from '@brightlayer-ui/colors';
import * as PXBColorsBranding from '@brightlayer-ui/colors-branding';
 
export const ChartColors = [
    PXBColors.lightBlue[300],
    PXBColors.gold[300],
    PXBColors.green[500],
    PXBColors.red[800],
    PXBColors.orange[700],
    PXBColors.blue[500],
    PXBColors.purple[300],
    PXBColors.red[100],
    PXBColorsBranding.teal[500],
    PXBColorsBranding.citron[500],
    PXBColorsBranding.pine[500],
    PXBColorsBranding.emerald[500],
    PXBColorsBranding.wine[500],
    PXBColorsBranding.crimson[500],
    PXBColorsBranding.sunset[500],
    PXBColorsBranding.rust[900],
    PXBColorsBranding.navy[500],
    PXBColorsBranding.sky[500],
    PXBColorsBranding.sage[500],
    PXBColorsBranding.toad[500],
    PXBColorsBranding.butter[500],
    PXBColorsBranding.trophy[500],
];
export const ChartColorsBackground = [
    PXBColors.lightBlue[500],
    PXBColors.gold[500],
    PXBColors.green[500],
    PXBColors.red[500],
    PXBColors.orange[500],
    PXBColors.blue[500],
    PXBColors.purple[500],
    PXBColors.red[500],
    PXBColorsBranding.teal[500],
    PXBColorsBranding.citron[500],
    PXBColorsBranding.pine[500],
    PXBColorsBranding.emerald[500],
    PXBColorsBranding.wine[500],
    PXBColorsBranding.crimson[500],
    PXBColorsBranding.sunset[500],
    PXBColorsBranding.rust[900],
    PXBColorsBranding.navy[500],
    PXBColorsBranding.sky[500],
    PXBColorsBranding.sage[500],
    PXBColorsBranding.toad[500],
    PXBColorsBranding.butter[500],
    PXBColorsBranding.trophy[500],
];
export const ChartColorsHover = [
    PXBColors.lightBlue[50],
    PXBColors.gold[50],
    PXBColors.green[50],
    PXBColors.red[50],
    PXBColors.orange[50],
    PXBColors.blue[50],
   PXBColors.purple[50],
    PXBColors.red[50],
    PXBColorsBranding.teal[50],
    PXBColorsBranding.citron[50],
    PXBColorsBranding.pine[50],
    PXBColorsBranding.emerald[50],
    PXBColorsBranding.wine[50],
    PXBColorsBranding.crimson[50],
    PXBColorsBranding.sunset[50],
    PXBColorsBranding.rust[100],
    PXBColorsBranding.navy[50],
    PXBColorsBranding.sky[50],
    PXBColorsBranding.sage[50],
    PXBColorsBranding.toad[50],
    PXBColorsBranding.butter[50],
    PXBColorsBranding.trophy[50],
];
 
 
